import { useTheme } from '@/context/ThemeContext'
import { styles } from '@/shell/layout.styles'

export function ThemeToggle() {
  const { theme, toggle } = useTheme()
  return (
    <button
      style={styles.themeToggle}
      onClick={toggle}
      aria-label="Toggle theme"
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {theme === 'dark' ? '☀' : '☽'}
    </button>
  )
}

